var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-items-center justify-content-center h-100 text"},[_vm._v("No "+_vm._s(_vm.page)+" to display")])}
var staticRenderFns = []

export { render, staticRenderFns }